export enum AdminTool {
  BULK_WIKIPEDIA = "bulk-wikipedia",
  BULK_BROWSERBASE = "bulk-browserbase",
}
